import React from "react"
import PropTypes from "prop-types"
import { File, Spacer } from "@bw/bits"

const Downloads = ({ files }) => {
  if (!files || files.length === 0) {
    return null
  }

  return (
    <Spacer>
      {files.map((file, i) => {
        return (
          <File
            key={i}
            title={file.title}
            href={file.fileUrl}
            description={file.description}
          />
        )
      })}
    </Spacer>
  )
}

Downloads.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      fileUrl: PropTypes.string,
    })
  ),
}

export { Downloads }
